import { createAsyncThunk } from '@reduxjs/toolkit';
import { MakeApiCallConfig, makeApiCall } from '../../utils/makeApiCall';
import { serializeError } from '../../utils/errorHandling';

export const createApiCallAction = (
  actionName: string,
  apiConfigs: MakeApiCallConfig
) => {
  return createAsyncThunk(actionName, async (_, { rejectWithValue }) => {
    try {
      return await makeApiCall(apiConfigs);
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  });
};

export const createApiCallActionWithParams = (
  actionName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getApiConfigs: (params?: any) => MakeApiCallConfig
) => {
  return createAsyncThunk(
    actionName,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (params: any, { rejectWithValue }) => {
      try {
        const configs = getApiConfigs(params || {});
        const result = await makeApiCall(configs);
        return result;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    }
  );
};
